import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import Swal from 'sweetalert2';

@Component({
  selector:    'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls:   ['./payment-success.component.css']
})
export class PaymentSuccessComponent implements OnInit {

  verifying = true;
  success   = false;
  planName  = '';
  error     = '';

  constructor(
    private route:               ActivatedRoute,
    private router:              Router,
    private subscriptionService: SubscriptionService
  ) {}

  ngOnInit(): void {
    // ✅ Paystack appends ?reference=xxx&trxref=xxx to callback URL
    const reference = this.route.snapshot.queryParamMap.get('reference')
                   || this.route.snapshot.queryParamMap.get('trxref')
                   || sessionStorage.getItem('paystack_reference');

    if (!reference) {
      this.verifying = false;
      this.error     = 'No payment reference found.';
      return;
    }

    this.verifyPayment(reference);
  }

  private verifyPayment(reference: string): void {
    this.subscriptionService.verifyPayment(reference).subscribe({
      next: (res) => {
        this.verifying = false;
        this.success   = true;
        this.planName  = res.plan ?? sessionStorage.getItem('paystack_plan') ?? '';

        // ✅ Clear sessionStorage
        sessionStorage.removeItem('paystack_reference');
        sessionStorage.removeItem('paystack_plan');
        sessionStorage.removeItem('paystack_cycle');

        // ✅ Reload subscription cache
        this.subscriptionService.loadCurrent().subscribe();

        // ✅ Show success alert
        Swal.fire({
          title:             'Subscription Activated!',
          html: `
            <p style="color:#374151; font-size:14px;">
              Welcome to <strong>${this.planName}</strong>!<br/>
              Your account has been upgraded successfully.
            </p>`,
          icon:              'success',
          confirmButtonText: 'Go to Dashboard',
          confirmButtonColor: '#2BB0A6',
          allowOutsideClick: false,
          customClass: { popup: 'swal-fieldops' }
        }).then(() => {
          this.router.navigate(['/dashboard']);
        });
      },
      error: () => {
        this.verifying = false;
        this.error     = 'Payment verification failed. Please contact support.';

        Swal.fire({
          title:             'Verification Failed',
          text:              'We could not verify your payment. Please contact support if you were charged.',
          icon:              'error',
          confirmButtonColor: '#2BB0A6',
          customClass: { popup: 'swal-fieldops' }
        });
      }
    });
  }

  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }
}